import React from 'react'
import { connect } from 'react-redux'
import clsx from 'clsx'
import { makeStyles, withStyles } from '@mui/styles'
import {
  ListItemText,
  ListItemIcon,
  ListItem,
  List,
  Drawer,
  Tooltip,
} from '@mui/material'
import {
  settingsIcon,
  settingsIconSelected,
} from '../../assets/fontawesome/settingsIcons'
import { wikiIcon, wikiIconSelected } from '../../assets/fontawesome/wikiIcons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { modules, moduleIsAvailable } from '../../utils/moduleConfig'
// import { menuBarsIcon } from '../../assets/fontawesome/menuBarsIcon'
// import { menuOverlayBreakpointDown, menuPushBreakpointUp } from './Navigation'

const CustomList = withStyles(theme => ({
  root: {
    padding: 0,
    width: '100%',
  },
}))(List)

const CustomListItem = withStyles(theme => ({
  root: {
    width: '100%',
    color: theme.palette.menu.icons,
    paddingTop: theme.spacing(1.75),
    paddingBottom: theme.spacing(1.75),
  },
  gutters: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))(ListItem)

const CustomListItemIcon = withStyles(theme => ({
  root: {
    color: theme.palette.menu.icons,
  },
}))(ListItemIcon)

const CustomListItemText = withStyles(theme => ({
  primary: {
    // sometimes still works
  },
  root: {
    '& .MuiListItemText-primary': {
      color: theme.palette.menu.text,
      fontSize: 14,
    },
  },
}))(ListItemText)

const useStyles = makeStyles(theme => ({
  drawer: {
    width: props => props.minDrawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerPaper: {
    overflowX: 'hidden',
    backgroundColor: theme.palette.menu.bg,
    top: 'auto',
    bottom: 0,
    border: `1px solid ${theme.palette.menu.border}`,
    // height: props => `calc(100% - ${props.topbarHeight}px)`,
    height: '100%',
    position: 'relative', // from your down breakpoint style, adjust if needed
  },
  drawerOpen: {
    width: props => props.minDrawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: props => props.minDrawerWidth,
  },
  mobileMenuItem: {
    height: props => props.topbarHeight,
  },
  topList: {
    top: 0,
    position: 'absolute',
    marginTop: '47px',
  },
  topListItem: {
    top: 0,
  },
  bottomList: {
    position: 'absolute',
    bottom: 0,
    paddingBottom: theme.spacing(0),
  },
  bottomListItem: {
    bottom: 0,
  },
  menuIcon: {
    margin: 'auto',
    '& path': {
      fill: theme.palette.menu.icons,
    },
  },
  selectedMenuIcon: {
    '& path': {
      fill: theme.palette.primary.main,
    },
  },
  profileIcon: {
    height: 35,
    width: 35,
    margin: 'auto',
  },
  listItemIcon: {
    minWidth: props => props.minDrawerWidth,
  },
  tooltipSelected: {
    color: '#368ED8',
    backgroundColor: '#e6f0fb',
    border: '1px solid #368ED8',
  },
  tooltipUnselected: {
    color: '#6e6e6e',
    backgroundColor: '#f0f0f0',
    border: '1px solid #b0b0b0',
  },
}))

const mapStateToProps = state => {
  return {}
}

const Sidebar = props => {
  const classes = useStyles(props)
  const { goTo, selectedMenuItem, availableModules } = props

  const handleItemClick = path => {
    goTo(path)
  }

  const selected = selectedMenuItem()

  /*
    Keep only permissions that map to a known module, so an unrecognized
    permission name in the DB can't crash the whole sidebar.
  */
  const knownModules = availableModules
    .filter(module => modules[module])
    .sort((a, b) => modules[a].route - modules[b].route)

  /*
    Remove the 'settings' module if it's present,
    as it's not included in the menu icons.
  */
  const isSettingsPresent = knownModules.includes('settings')
  const menuAvailableModules = isSettingsPresent
    ? knownModules.filter(module => module !== 'settings')
    : knownModules

  const renderMenuIcon = module => {
    return (
      moduleIsAvailable(module.id, menuAvailableModules) && (
        <Tooltip
          key={module.id}
          classes={{
            tooltip:
              selected === module.route
                ? classes.tooltipSelected
                : classes.tooltipUnselected,
          }}
          title={module.title}
          placement="right-start"
        >
          <CustomListItem
            className={classes.topListItem}
            button
            key={module.id}
            onClick={() => handleItemClick(module.url)}
          >
            <CustomListItemIcon className={classes.listItemIcon}>
              <FontAwesomeIcon
                icon={
                  selected === module.route
                    ? module.icon.selected
                    : module.icon.default
                }
                size={'lg'}
                className={clsx(
                  classes.menuIcon,
                  selected === module.route && classes.selectedMenuIcon,
                )}
              />
            </CustomListItemIcon>
            <CustomListItemText primary={module.name} />
          </CustomListItem>
        </Tooltip>
      )
    )
  }

  return (
    <>
      <Drawer
        // variant={menuOverlay ? 'temporary' : 'permanent'}
        variant="permanent"
        anchor={'left'}
        open={false}
        // onClose={handleDrawerChange}
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: false,
          [classes.drawerClose]: true,
        })}
        classes={{
          paper: clsx(classes.drawerPaper, {
            [classes.drawerOpen]: false,
            [classes.drawerClose]: true,
          }),
        }}
      >
        <CustomList className={classes.topList}>
          {/* <CustomListItem
            className={clsx(classes.topListItem, classes.burgerMenuItem)}
            button
            key={'Menu'}
            onClick={handleDrawerChange}
          >
            <CustomListItemIcon className={classes.listItemIcon}>
              <FontAwesomeIcon
                icon={menuBarsIcon}
                size={'lg'}
                className={classes.menuIcon}
              />
            </CustomListItemIcon>
            <CustomListItemText primary={'Menu'} />
          </CustomListItem> */}
          {knownModules.map(moduleId => {
            return renderMenuIcon(modules[moduleId])
          })}
        </CustomList>

        <CustomList className={classes.bottomList}>
          <Tooltip
            key={modules.wiki.title}
            title={modules.wiki.title}
            placement="right-start"
            classes={{
              tooltip:
                selected === modules.wiki.route
                  ? classes.tooltipSelected
                  : classes.tooltipUnselected,
            }}
          >
            <CustomListItem
              className={classes.bottomListItem}
              button
              key={modules.wiki.title}
              onClick={() => goTo(modules.wiki.url)}
            >
              <CustomListItemIcon className={classes.listItemIcon}>
                <FontAwesomeIcon
                  icon={
                    selected === modules.wiki.route
                      ? wikiIconSelected
                      : wikiIcon
                  }
                  size={'lg'}
                  className={clsx(
                    classes.menuIcon,
                    selected === modules.wiki.route && classes.selectedMenuIcon,
                  )}
                />
              </CustomListItemIcon>
              <CustomListItemText primary={modules.wiki.name} />
            </CustomListItem>
          </Tooltip>
          {isSettingsPresent && (
            <Tooltip
              key={modules.settings.title}
              title={modules.settings.title}
              placement="right-start"
              classes={{
                tooltip:
                  selected === modules.settings.route
                    ? classes.tooltipSelected
                    : classes.tooltipUnselected,
              }}
            >
              <CustomListItem
                className={classes.bottomListItem}
                button
                key={modules.settings.title}
                onClick={() => goTo(modules.settings.url)}
              >
                <CustomListItemIcon className={classes.listItemIcon}>
                  <FontAwesomeIcon
                    icon={
                      selected === modules.settings.route
                        ? settingsIconSelected
                        : settingsIcon
                    }
                    size={'lg'}
                    className={clsx(
                      classes.menuIcon,
                      selected === modules.settings.route &&
                        classes.selectedMenuIcon,
                    )}
                  />
                </CustomListItemIcon>
                <CustomListItemText primary={modules.settings.name} />
              </CustomListItem>
            </Tooltip>
          )}
        </CustomList>
      </Drawer>
    </>
  )
}

export default connect(mapStateToProps, null)(Sidebar)
